import * as editPropertyDetailsActions from '../actions/editPropertyDetails';

const defaultState = {
    isLoading: true,
    isShowingAddressLookup: false,
    form: {
        initialValues: {},
        initialStatus: {
            errors: {},
        },
    },
    propertyTypes: [],
    propertyDetachments: [],
    propertyAges: [],
    addresses: null,
    selectedAddress: null,
    isLoadingAddresses: false,
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case editPropertyDetailsActions.FORM_REFRESHED:
            return {
                ...state,
                form: action.form,
            };
        case editPropertyDetailsActions.PROPERTY_TYPES_REFRESHED:
            return {
                ...state,
                propertyTypes: action.propertyTypes,
            };
        case editPropertyDetailsActions.PROPERTY_DETACHMENTS_REFRESHED:
            return {
                ...state,
                propertyDetachments: action.propertyDetachments,
            };
        case editPropertyDetailsActions.PROPERTY_AGES_REFRESHED:
            return {
                ...state,
                propertyAges: action.propertyAges,
            };
        case editPropertyDetailsActions.TOGGLE_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case editPropertyDetailsActions.SHOW_ADDRESS_LOOKUP:
            return {
                ...state,
                isShowingAddressLookup: true,
            };
        case editPropertyDetailsActions.HIDE_ADDRESS_LOOKUP:
            return {
                ...state,
                isShowingAddressLookup: false,
                selectedAddress: null,
                addresses: null,
            };
        case editPropertyDetailsActions.ADDRESSES_REFRESHED:
            return {
                ...state,
                addresses: action.addresses,
            };
        case editPropertyDetailsActions.ADDRESS_SELECTED:
            return {
                ...state,
                selectedAddress: action.address,
            };
        case editPropertyDetailsActions.TOGGLE_LOADING_ADDRESSES:
            return {
                ...state,
                isLoadingAddresses: action.isLoading,
            };
        case editPropertyDetailsActions.CLEAR_ADDRESSES:
            return {
                ...state,
                addresses: null,
                selectedAddress: null,
            };
        case editPropertyDetailsActions.RESET:
            return defaultState;
        default:
            return state;
    }
}
